import React, { Component } from 'react';
import { Button } from './CommonUiComponents';
import {
  LoginErrorText,
  LoginFormTitle,
  LoginInputField,
  LoginInputLabel,
  StyledLoginForm,
  LoginLink,
  LoginButtonWrapper
} from '../style-guide/Login';

export default class LoginForm extends Component {
  state = {
    username: '',
    password: ''
  };

  handleLogin = e => {
    const { login } = this.props;
    const { username, password } = this.state;

    e.preventDefault();

    login(username, password);
  };

  handleInputValue = e => {
    const { name, value } = e.target;

    this.setState({
      [name]: value
    });
  };

  render() {
    const { loggingIn, invertedTheme, loginError, hasAccess } = this.props;

    return (
      <StyledLoginForm onSubmit={this.handleLogin} method="POST">
        <LoginFormTitle inverted={invertedTheme}>
          Logg inn for å få tilgang til boken og «Min side»
        </LoginFormTitle>
        <LoginInputLabel htmlFor={'username'} inverted={invertedTheme}>
          Brukernavn / E-post
        </LoginInputLabel>
        <LoginInputField
          type="text"
          name="username"
          id="username"
          onChange={this.handleInputValue}
          disabled={loggingIn}
          inverted={invertedTheme}
          required
        />
        <LoginInputLabel htmlFor={'password'} inverted={invertedTheme}>
          Passord
        </LoginInputLabel>
        <LoginInputField
          type="password"
          name="password"
          id="password"
          onChange={this.handleInputValue}
          disabled={loggingIn}
          inverted={invertedTheme}
          required
        />
        {loginError ? (
          <LoginErrorText inverted={invertedTheme}>
            Feil brukernavn eller passord.
          </LoginErrorText>
        ) : (
          <span>
            {!hasAccess && (
              <div>
                <p>
                  Du har ikke tilgang til denne boken!{' '}
                  <LoginLink to="ny-lisens" noGutterTop>
                    Registrer lisensnøkkel her
                  </LoginLink>{' '}
                </p>
              </div>
            )}
          </span>
        )}

        <LoginButtonWrapper>
          <Button type="submit" disabled={loggingIn}>
            {loggingIn ? 'Logger inn...' : 'Logg inn'}
          </Button>
          <LoginLink to="logg-inn/glemt">Glemt passord?</LoginLink>
          <LoginLink noGutterTop to="registrer">
            Registrer ny bruker
          </LoginLink>
        </LoginButtonWrapper>
      </StyledLoginForm>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/LoginForm.js